export default "__VITE_ASSET__5f1d3adb__"